import styled from 'styled-components';
import { mobileMediaQuery } from '../utils/responsive';

const FormContainer = styled.div`
  background: #fafafa;
  border: 1px solid rgba(33, 33, 33, 0.2);
  border-radius: 10px;
  padding: 25px;
  margin: 0 auto;
  width: 50%;
  @media ${mobileMediaQuery} {
    width: 100%;
  }
  overflow: scroll;
`;

export default FormContainer;
